import React, { useEffect, useState } from "react";
import Images from "../../constant/Images";

// Tolerant name extraction. Handles:
//  - plain strings (places)
//  - JSON arrays parsed by Sequelize (tours/bundles with multi-lang)
//  - JSON-stringified arrays (new bundles stored as TEXT)
//  - double-encoded JSON (historical bad data)
const extractName = (raw: any): string => {
  if (!raw) return "";
  if (Array.isArray(raw)) {
    const en = raw.find((x: any) => x?.language === "en") || raw[0];
    return (en?.text || "").toString();
  }
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (trimmed.startsWith("[") || trimmed.startsWith('"')) {
      try {
        const parsed = JSON.parse(trimmed);
        return extractName(parsed);
      } catch {
        return raw;
      }
    }
    return raw;
  }
  return "";
};

const SearchComponent = (data: any) => {
  const [searchItem, setSearchItem] = useState<any>(data);
  const [searchValue, setSearchValue] = useState<any>();
  const [searchData, setSearchData] = useState<any>();
  useEffect(() => {
    setSearchItem(data);
  }, [data]);

  const handleChange = (e: any) => {
    let searchList: any = { ...searchItem };
    setSearchValue(e.target.value);
    if (e.target.value.trim() === "") {
      data?.getSearchData(searchList);
      return;
    }
    if (!e.target.validity.valueMissing) {
      const query = e.target.value.toLowerCase();
      searchList =
        searchList?.data?.length &&
        searchList.data?.filter((item: any) => {
          const name = extractName(item?.name).toLowerCase();
          if (!name) return false;
          return name.includes(query) || query.includes(name);
        });
      setSearchData(searchList);
    } else {
      data?.getSearchData && data?.getSearchData(searchList);
    }
  };

  useEffect(() => {
    data?.getSearchData && data?.getSearchData(searchData, searchValue);
  }, [searchData]);

  return (
    <>
      <div className="relative mt-6 flex">
        <img
          className="absolute top-[10px] left-[16px] h-5 "
          src={Images.search}
          alt=""
        />
        <input
          type="search"
          className=" w-[538px] h-10 p-4 pl-10 text-sm text-gray-900 border border-aqua rounded-3xl font-roboto font-normal focus:outline-none cursor-pointer"
          placeholder="Search"
          required
          onChange={handleChange}
          value={searchValue}
        ></input>
      </div>
    </>
  );
};

export default SearchComponent;
